import { SelectorConfiguration } from 'selectorConfiguration';

export default {
	startup: [],
} as SelectorConfiguration;